import React from 'react';
import { Modal } from 'react-bootstrap';
import { toast } from 'sonner';
import { FileExplorerModalProps } from '../../../types/fileExplorerTypes';
import { deleteFile, TreeFile } from '../services';
import { ControlledAlertModal } from '../../common/ControlledModal';
import { useFileExplorerMutation } from '../../../hooks/useFileExplorerMutation';

const GENERIC_ERROR_MESSAGE = 'Ocurrió un error al eliminar el archivo, por favor intenta nuevamente.';

export function DeleteFileModal({ show, onHide, data }: FileExplorerModalProps<TreeFile>) {
  if (!data) return null;

  const handleSuccess = () => {
    onHide?.();
  };

  const mutationFn = () => deleteFile(data.id);
  const {
    mutateAsync, isLoading, reset,
  } = useFileExplorerMutation({
    mutationFn,
    onSuccess: handleSuccess,
  });

  const handleDelete = (id: string) => {
    const deletePromise = mutateAsync(id);
    toast.promise(deletePromise, {
      loading: 'Eliminando archivo...',
      success: 'Archivo eliminado exitosamente',
      error: {
        message: 'Error al eliminar el archivo',
        description: GENERIC_ERROR_MESSAGE,
      },
    });
  };

  const handleClose = () => {
    reset();
    onHide?.();
  };

  return (
    <ControlledAlertModal
      show={show}
      onHide={handleClose}
      title="¿Está seguro/a?"
      description="Esta acción no se puede deshacer. Esto eliminará permanentemente el archivo."
      closeButton
      centered
    >
      <Modal.Footer>

        <ControlledAlertModal.Actions
          handleClose={handleClose}
          onConfirm={() => handleDelete(data.id.toString())}
          isPending={isLoading}
        />
      </Modal.Footer>
    </ControlledAlertModal>
  );
}
